import { __rest } from "tslib";
import React from 'react';
import { connectField, filterDOMProps, injectName, joinName } from 'uniforms';
import AutoField from './AutoField';

var Nest = function Nest(_a) {
  var children = _a.children,
      error = _a.error,
      errorMessage = _a.errorMessage,
      fields = _a.fields,
      itemProps = _a.itemProps,
      label = _a.label,
      name = _a.name,
      showInlineError = _a.showInlineError,
      props = __rest(_a, ["children", "error", "errorMessage", "fields", "itemProps", "label", "name", "showInlineError"]);

  return React.createElement("div", Object.assign({}, filterDOMProps(props)), label && React.createElement("label", null, label), !!(error && showInlineError) && React.createElement("div", null, errorMessage), children ? injectName(name, children) : fields.map(function (key) {
    return React.createElement(AutoField, Object.assign({
      key: key,
      name: joinName(name, key)
    }, itemProps));
  }));
};

export default connectField(Nest, {
  ensureValue: false,
  includeInChain: false
});